import { createAction, props } from '@ngrx/store';
import {
	IGqlMassMessages,
	IMassMessage,
	IMessageText,
} from '../interfaces/messages.interfaces';
import {
	IAuPaginationData,
	IDjangoPaginationData,
} from '@app/shared/ui-components/au-paginator/pagination-page.info';
import { IUser } from '@app/shared/interfaces/user.interface';

export const addMessage = createAction(
	'[MESSAGES] Add Message',
	props<{ messages: IMassMessage; currentUser: IUser }>()
);

export const setMessages = createAction(
	'[MESSAGES] Set Messages',
	props<{ messages: IGqlMassMessages[]; messagesPagination: IDjangoPaginationData }>()
);

export const setPaginationOptions = createAction(
	'[MESSAGES] Set Pagination Options',
	props<{ paginationOptions: IAuPaginationData }>()
);

export const clearMessages = createAction('[MESSAGES] Clear Messages');

export const loadPaginatedData = createAction('[MESSAGES] Load Paginated Data');

export const handlePaginatedData = createAction(
	'[MESSAGES] Handle Paginated Data',
	props<{
		paginatedData: {
			messagesPagination: IDjangoPaginationData;
			messages: IGqlMassMessages[];
		};
	}>()
);

export const setIsLoading = createAction(
	'[MESSAGES] Is Loading Messages',
	props<{ isLoading: boolean }>()
);

export const setViewMessage = createAction(
	'[MESSAGES] Set View Message',
	props<{ viewMessage: IGqlMassMessages }>()
);

export const clearViewMessage = createAction('[MESSAGES] Clear View Message');

export const openNewMessage = createAction('[MESSAGES] Open new message workspace');

export const setMessageExternalDate = createAction(
	'[MESSAGES] Open message external data',
	props<{ messageText: IMessageText }>()
);

export const clearMessageExternalDate = createAction(
	'[MESSAGES] Clear message external data'
);
